export default "__VITE_ASSET__DIz5dccl__"